module.exports = __webpack_public_path__ + "img/plan-your-meals.39e487ff.png";